import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { Section, Reveal, SectionTitle } from './Section';
const testimonials = [{
  quote: 'Ahora termino las correcciones mucho antes y ya no paso mis domingos rodeada de exámenes.',
  name: 'María C.',
  country: 'Perú',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/ce9d3907-c33f-4d8d-9a55-3f2f52e08c68.jpg'
}, {
  quote: 'Los comentarios listos para usar y las plantillas hicieron que todo fuera mucho más rápido.',
  name: 'Andrea G.',
  country: 'Colombia',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/fda556b0-256e-4192-b0d9-05d0f9181869.jpg'
}, {
  quote: 'Pensé que solo serían algunos PDFs, pero terminé cambiando completamente mi forma de evaluar.',
  name: 'Patricia R.',
  country: 'Chile',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/12902189-2226-495b-b397-071eb954fa83.jpg'
}];
export function Testimonials() {
  return <Section className="bg-white" data-id="element-185">
      <Reveal className="text-center" data-id="element-186">
        <SectionTitle data-id="element-187">
          Lo que dicen docentes que ya recuperaron su tiempo
        </SectionTitle>
      </Reveal>

      <div className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-188">
        {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.08} className="flex flex-col rounded-3xl bg-brand-cream p-6 shadow-sm ring-1 ring-brand-purple/10" data-id="element-189">
            <QuoteIcon className="h-7 w-7 text-brand-purple/25" data-id="element-190" />
            <div className="mt-2 flex gap-0.5" data-id="element-191">
              {Array.from({
            length: 5
          }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-brand-orange text-brand-orange" data-id="element-192" />)}
            </div>
            <p className="mt-3 flex-1 text-sm font-semibold leading-relaxed text-brand-purpleDark/85" data-id="element-193">
              “{t.quote}”
            </p>
            <div className="mt-5 flex items-center gap-3" data-id="element-194">
              <img src={t.img} alt={`Foto de ${t.name}, docente de ${t.country}`} className="h-12 w-12 rounded-full object-cover ring-2 ring-brand-purple/20" loading="lazy" data-id="element-195" />
              <div data-id="element-196">
                <p className="font-display text-sm font-extrabold text-brand-purpleDark" data-id="element-197">
                  {t.name}
                </p>
                <p className="text-xs font-semibold text-brand-purpleDark/60" data-id="element-198">
                  {t.country}
                </p>
              </div>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}